<template>
  <div id="app" :class="themeClass">
    <!-- Global Notifications -->
    <GlobalNotifications />
    <!-- Barre de navigation (cachée sur les pages admin) -->
    <Navigation v-if="!isAdminRoute"/>
    <!-- Vue -->
    <router-view v-slot="{ Component }">
      <transition @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter" name="fade" mode="out-in">
        <component :is="Component" :key="$route.fullPath" class="minimum-height"/>
      </transition>
    </router-view>
    <!-- Pied de page (caché sur les pages admin) -->
     <cookie-consent @cookies-updated="handleCookiesUpdate"/>
    <Footer v-if="!isAdminRoute"/>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import CookieConsent from '@/components/CookieConsent.vue';
import GlobalNotifications from '@/components/GlobalNotifications.vue';
import { useThemeStore } from '@/stores/theme';

export default {
  components: {Footer, Navigation, CookieConsent, GlobalNotifications},
  data() {
    return {
      prevHeight: 0,
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    },
    themeClass() {
      const themeStore = useThemeStore();
      return themeStore.activeTheme ? `theme-${themeStore.activeTheme}` : 'theme-default';
    }
  },
  watch: {
    // Watch for role changes to update theme
    '$store.getters.role': {
      handler(newRole) {
        const themeStore = useThemeStore();
        themeStore.setThemeFromRole(newRole);
      },
      immediate: true
    }
  },
  mounted() {
    // Initialize theme on app mount
    const themeStore = useThemeStore();
    themeStore.initTheme();
    
    // Check for existing cookie consent
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent) {
      const cookies = JSON.parse(cookieConsent);
      this.handleCookiesUpdate(cookies);
    }
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const {height} = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    handleCookiesUpdate(cookies) {
      if (cookies.analytics) {
        // Initialize Hotjar when analytics cookies are enabled
        if (window.initHotjar) {
          window.initHotjar();
        }
      } else {
        // Disable Hotjar when analytics cookies are disabled
        if (window.hj) {
          // Tell Hotjar to opt this user out of tracking
          window.hj('optOut');
        }
      }
      
      // Remove marketing-related code if you're not using it
      // if (cookies.marketing) {
      //   // Initialiser les outils marketing
      // }
    },
  }
}
</script>

<style>
/* Police d'écrite du site */
@import url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible&display=swap');


@import "assets/main.css";

#app {
  font-family: 'Atkinson Hyperlegible', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #424242;
}


/* Transition entre les pages */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.minimum-height {
  min-height: 93vh;
  padding-top: 70px; /* Space for fixed navbar */
}
</style>